/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect } from "react";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import PersonIcon from "@/src/assets/icons/provision/toggleable/IconPerson";
import { requiredValidator } from "@/src/services/validationRules";
import { useForm } from "@/src/provider/Form/FormProvider";
import Group from "@/src/components/Wizard/Group";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box } from "@mui/material";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import { translate } from "@/src/services/translations/translations";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import IconHouse from "@/src/assets/icons/provision/toggleable/IconHouse";

type RentalContractBaseProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
};
export default function RentalContractContractPartyType({ submitProps, product }: RentalContractBaseProps) {
  const { handleSubmit, values, handleChange } = useForm();

  useEffect(() => {
    handleChange({
      target: {
        name: "reasonForDispute",
        value: values.contractPartyType === "landlord" ? "other" : null,
      },
    });
    return;
  }, [values.contractPartyType]);

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline"
            }}>
            <Grid sx={wizardStyle.gridTopSpaced} size={12}>
              <Group
                type="radio"
                name="contractPartyType"
                question={translate("rentalContract.contractPartyType.question", product)}
                options={[
                  {
                    labelText: translate("rentalContract.contractPartyType.options.tenant.label", product),
                    labelIcon: <PersonIcon />,
                    labelIconActive: <PersonIcon active />,
                    value: "tenant",
                  },
                  {
                    labelText: translate("rentalContract.contractPartyType.options.landlord.label", product),
                    labelIcon: <IconHouse />,
                    labelIconActive: <IconHouse active />,
                    value: "landlord",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
